import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { documentSuggestionsApi } from 'src/Services/API';
import { DocumentSuggestionDto } from 'src/Services/API/generated';

export interface AcceptDocumentSuggestionVariables {
  suggestionId: string;
  name?: string;
  path?: string;
}

export const useAcceptDocumentSuggestion = (
  options?: UseMutationOptions<DocumentSuggestionDto, unknown, AcceptDocumentSuggestionVariables>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<DocumentSuggestionDto, unknown, AcceptDocumentSuggestionVariables>(
    'accept-document-suggestion',
    async ({ suggestionId, name, path }) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await documentSuggestionsApi.documentClassificationControllerAccept(
        assetId,
        suggestionId,
        { name, path }
      );
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries({ queryKey: ['document-suggestions', assetId] });
        queryClient.invalidateQueries({ queryKey: ['fetch-documents', assetId] });
      },
    }
  );
};
